module.exports = __webpack_public_path__ + "img/edge_divers_tel_portable.09538944.svg";